export default {
  setInvitation: (state, invitation) => {
    state.invitation = invitation
  },
  setError: (state, err) => {
    state.error = err;
  },
}
